module.exports = __webpack_public_path__ + "static/smerdova-4e012c26a21e3fb4acc6141cf435da7d.jpg";